import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { Button } from "~/components/button";
import { ColorPicker } from "~/components/color-picker";

import { Popover } from "../../react/popover/Popover";

import type { FormState } from "./form-state";
import { PRESET } from "./settings";

export interface WidgetColorProps {
	className?: string;
	color: FormState;
}

export const WidgetColor: React.FC<WidgetColorProps> = ({ className, color }) => {
	const monitor = useMonitor();

	return (
		<Popover
			className={className}
			content={
				<ColorPicker
					color={color.getInput(monitor)}
					onChange={(value) => color.setInput(value)}
					presetColors={PRESET}
				/>
			}
			destroyTooltipOnHide
			trigger="click"
		>
			<Button className="rounded-full" icon size="sm" variant="neutral">
				<div className="size-6 rounded-full" style={{ backgroundColor: color.getInput(monitor) }} />
			</Button>
		</Popover>
	);
};
